export default __webpack_public_path__ + "static/media/Pos3.71320e1c.svg";